import React from "react"
import { FaHome, FaCheck, FaRegSun, FaShopify, FaUserPlus, FaUserTag, FaTicketAlt, FaList, FaDatabase, FaPhoneAlt, FaProductHunt, FaSlidersH, FaUserTie, FaUserTimes, FaHandHolding, FaUserMinus, FaBusinessTime, FaCalendar, FaFileContract, FaRegMoneyBillAlt, FaChartLine, FaHistory, FaHeadset, FaIdBadge, FaCoins, FaClock, FaHandHoldingUsd, FaBoxOpen, FaCog, FaFileInvoiceDollar } from 'react-icons/fa'
import { FaListCheck } from 'react-icons/fa6'
import { BsDatabaseFillAdd } from "react-icons/bs";
import { BiSolidContact } from "react-icons/bi";

const user = JSON.parse(sessionStorage.getItem('user'))

const ROLES = {
  ADMIN: 2,
  LIDER_ADMINISTRATIVO: 111,
  COBRANZA_CARTERA: 117,
  COMERCIAL: 101,
  SOPORTE: 102,
  RECURSOS_HUMANOS: 108,
  RECEPCION: 115,
  NOMINA: 109,
  AGENTE: 110
};

const Admin = [
  {
    type: "groupHeader",
    groupTitle: "SECCIÓN CRM TIC"
  },
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  // {
  //   type: "groupHeader",
  //   groupTitle: "MÓDULO CONFIGURACIÓN"
  // },
  {
    id: "indicadores",
    title: "Indicadores",
    type: "item",
    icon: <FaChartLine size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/indicadores"
  },
  {
    id: "Gestion de Bases",
    title: "Gestion de Bases",
    type: "collapse",
    icon: <FaDatabase size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Bases",
        title: "Bases",
        type: "item",
        icon: <BsDatabaseFillAdd size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/bases"
      },
      {
        id: "Gestion de numeros",
        title: "Gestion de numeros",
        type: "item",
        icon: <BiSolidContact size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-numeros"
      },
    ]
  },
  {
    id: "GestionComercialModule",
    title: "Gestión Comercial",
    type: "collapse",
    icon: <FaBusinessTime size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "GestionComercial",
        title: "Gestión comercial",
        type: "item",
        icon: <FaBusinessTime size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-comercial"
      },
      {
        id: "GestionComercialHistorial",
        title: "Historial Gestión comercial",
        type: "item",
        icon: <FaHistory size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-comercial-historial"
      },
      {
        id: "Contratos",
        title: "Contratos",
        type: "item",
        icon: <FaFileContract size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/contratos"
      },
      {
        id: "ContratosHistorial",
        title: "Historial Contratos",
        type: "item",
        icon: <FaHistory size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/contratos-historial"
      },
      {
        id: "PlantillasContratos",
        title: "Plantillas Contratos",
        type: "item",
        icon: <FaFileContract size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/contratos-plantillas"
      }
    ]
  },
  {
    id: "Facturacion",
    title: "Facturación",
    type: "collapse",
    icon: <FaRegMoneyBillAlt size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Facturas",
        title: "Facturas",
        type: "item",
        icon: <FaRegMoneyBillAlt size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/facturacion"
      },
      {
        id: "FacturasHistorial",
        title: "Historial Facturas",
        type: "item",
        icon: <FaHistory size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/facturacion-historial"
      },
      {
        id: "Cobros",
        title: "Cobros",
        type: "item",
        icon: <FaHandHoldingUsd size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/facturacion-cobros"
      },
      {
        id: "facturacion-automatica",
        title: "Facturación Automática",
        type: "item",
        icon: <FaCog size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/facturacion-automatica"
      },
      {
        id: "facturas-terceros",
        title: "Facturas Terceros",
        type: "item",
        icon: <FaFileInvoiceDollar size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/facturas-terceros"
      },
    ]
  },
  {
    id: "producto-inhouse",
    title: "Productos Inhouse",
    type: "item",
    icon: <FaBoxOpen size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/producto-inhouse"
  },
  {
    id: "soporte",
    title: "Soporte",
    type: "collapse",
    icon: <FaHeadset size={20} />,
    permissions: ["admin", "editor"],
    children: [
      // {
      //   id: "ProductsRequest",
      //   title: "Solicitud por producto",
      //   type: "item",
      //   icon: <FaProductHunt size={20} />,
      //   permissions: ["admin", "editor"],
      //   navLink: "/product-request"
      // },
      {
        id: "soporte-tickets",
        title: "Gestión de tickets",
        type: "item",
        icon: <FaHeadset size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/soporte/tickets"
      },
      {
        id: "soporte-centro-admin",
        title: "Centro de soporte",
        type: "item",
        icon: <FaSlidersH size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/soporte/centro-soporte"
      },
      {
        id: "soporte-inventario",
        title: "Inventario",
        type: "item",
        icon: <FaDatabase size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/soporte/inventario"
      },
    ]
  },
  {
    id: "Agenda",
    title: "Agenda",
    type: "item",
    icon: <FaCalendar size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/agenda"
  },
  {
    id: "ClientesModulo",
    title: "Clientes",
    type: "collapse",
    icon: <FaUserTie size={16} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Clientes",
        title: "Clientes",
        type: "item",
        icon: <FaUserTie size={16} />,
        permissions: ["admin", "editor"],
        navLink: "/cliente",
      },
      {
        id: "Productos",
        title: "Productos",
        type: "item",
        icon: <FaShopify size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/products"
      },
    ]
  },
  {
    id: "NominaModulo",
    title: "Nómina",
    type: "collapse",
    icon: <FaUserTimes size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "MiHojaVida",
        title: "Mi Hoja Vida",
        type: "item",
        icon: <FaIdBadge size={16} />,
        permissions: ["admin", "editor"],
        navLink: "/mi-hoja-vida"
      },
      {
        id: "misPrestamos",
        title: "Mis Prestamos",
        type: "item",
        icon: <FaCoins size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/mis-prestamos",
      },
      {
        id: "Prestamos",
        title: "Prestamos",
        type: "item",
        icon: <FaCoins size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/prestamos",
      },
      {
        id: "Inasistencias",
        title: "Inasistencias",
        type: "item",
        icon: <FaClock size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/inasistencias"
      }
    ]
  },
  // {
  //   id: "MiHojaVida",
  //   title: "Mi Hoja Vida",
  //   type: "item",
  //   icon: <FaHome size={20} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/mi-hoja-vida"
  // },
  {
    id: "gsistema",
    title: "Sistema",
    type: "collapse",
    icon: <FaRegSun size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "sistema1",
        title: "Usuarios",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/users"
      },
      {
        id: "roles",
        title: "Roles",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/roles"
      },
      {
        id: "sistema3",
        title: "Centro de costos",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/centro-costo"
      },
      {
        id: "sistema4",
        title: "Cargo",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/cargo"
      },
      {
        id: "sistema5",
        title: "Area",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/area"
      },
    ]
  },
  // {
  //   id: "misPrestamos",
  //   title: "Mis Prestamos",
  //   type: "item",
  //   icon: <FaHandHolding size={12} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/mis-prestamos",
  // },
  // {
  //   id: "Prestamos",
  //   title: "Prestamos",
  //   type: "item",
  //   icon: <FaHandHolding size={12} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/prestamos",

  // },
  // {
  //   id: "Inasistencias",
  //   title: "Inasistencias",
  //   type: "item",
  //   icon: <FaUserTimes size={20} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/inasistencias"
  // }
  /* {
    type: "groupHeader",
    groupTitle: "SECCIÓN ALANIA"
  },
  {
    id: "Alaniasistema",
    title: "Sistema",
    type: "collapse",
    icon: <FaRegSun size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "AlaniasistemaUsuarios",
        title: "Usuarios",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/users"
      },
    ]
  }, */
];

const RecursosHumanos = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
      {
        id: "MiHojaVida",
        title: "Mi Hoja Vida",
        type: "item",
        icon: <FaIdBadge size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/mi-hoja-vida"
      },
      {
        id: "misPrestamos",
        title: "Mis Prestamos",
        type: "item",
        icon: <FaCoins size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/mis-prestamos",
      },
  {
    id: "Prestamos",
    title: "Prestamos",
    type: "item",
    icon: <FaCoins size={12} />,
    permissions: ["admin", "editor"],
    navLink: "/prestamos",

  },
  {
    id: "gsistema",
    title: "Sistema",
    type: "collapse",
    icon: <FaRegSun size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "sistema1",
        title: "Usuarios",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/users"
      },
      {
        id: "roles",
        title: "Roles",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/roles"
      },
      {
        id: "sistema3",
        title: "Centro de costos",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/centro-costo"
      },
      {
        id: "sistema4",
        title: "Cargo",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/cargo"
      },
      {
        id: "sistema5",
        title: "Area",
        type: "item",
        icon: <FaCheck size={12} />,
        permissions: ["admin", "editor"],
        navLink: "/area"
      },
    ]
  },
      {
        id: "Inasistencias",
        title: "Inasistencias",
        type: "item",
        icon: <FaClock size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/inasistencias"
      }
];

const Soporte = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
    {
    id: "soporte",
    title: "Soporte",
    type: "collapse",
    icon: <FaHeadset size={20} />,
    permissions: ["admin", "editor"],
    children: [
      // {
      //   id: "ProductsRequest",
      //   title: "Solicitud por producto",
      //   type: "item",
      //   icon: <FaProductHunt size={20} />,
      //   permissions: ["admin", "editor"],
      //   navLink: "/product-request"
      // },
      {
        id: "soporte-tickets",
        title: "Gestión de tickets",
        type: "item",
        icon: <FaHeadset size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/soporte/tickets"
      },
      {
        id: "soporte-centro-admin",
        title: "Centro de soporte",
        type: "item",
        icon: <FaSlidersH size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/soporte/centro-soporte"
      },
      {
        id: "soporte-inventario",
        title: "Inventario",
        type: "item",
        icon: <FaDatabase size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/soporte/inventario"
      },
    ]
  },
  {
    id: "Agenda",
    title: "Agenda",
    type: "item",
    icon: <FaCalendar size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/agenda"
  },
  {
    id: "MiHojaVida",
    title: "Mi Hoja Vida",
    type: "item",
    icon: <FaIdBadge size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/mi-hoja-vida"
  },
  {
    id: "misPrestamos",
    title: "Mis Prestamos",
    type: "item",
    icon: <FaCoins size={12} />,
    permissions: ["admin", "editor"],
    navLink: "/mis-prestamos",
  }
];

const Nomina = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "Prestamos",
    title: "Prestamos",
    type: "item",
    icon: <FaCoins size={12} />,
    permissions: ["admin", "editor"],
    navLink: "/prestamos",

  },
  {
    id: "MiHojaVida",
    title: "Mi Hoja Vida",
    type: "item",
    icon: <FaIdBadge size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/mi-hoja-vida"
  },
  {
    id: "misPrestamos",
    title: "Mis Prestamos",
    type: "item",
    icon: <FaCoins size={12} />,
    permissions: ["admin", "editor"],
    navLink: "/mis-prestamos",
  },
  {
    id: "Inasistencias",
    title: "Inasistencias",
    type: "item",
    icon: <FaUserTimes size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/inasistencias"
  }
];

const Agente = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "MiHojaVida",
    title: "Mi Hoja Vida",
    type: "item",
    icon: <FaIdBadge size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/mi-hoja-vida"
  },
  {
    id: "misPrestamos",
    title: "Mis Prestamos",
    type: "item",
    icon: <FaCoins size={12} />,
    permissions: ["admin", "editor"],
    navLink: "/mis-prestamos",
  },
  {
    id: "ClientesModulo",
    title: "Clientes",
    type: "collapse",
    icon: <FaUserTie size={16} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "crear-cliente",
        title: "Crear cliente",
        type: "item",
        icon: <FaUserTie size={16} />,
        permissions: ["admin", "editor"],
        navLink: "/cliente",
      },
      {
        id: "Productos",
        title: "Productos",
        type: "item",
        icon: <FaShopify size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/products"
      }
    ]
  },
  // {
  //   id: "Opciones cliente",
  //   title: "Opciones cliente",
  //   type: "collapse",
  //   icon: <FaUserTie size={20} />,
  //   permissions: ["admin", "editor"],
  //   children: [
  //     {
  //       id: "crear-cliente",
  //       title: "gestión cliente",
  //       type: "item",
  //       icon: <FaCheck size={12} />,
  //       permissions: ["admin", "editor"],
  //       navLink: "/cliente",
  //     },
  //     {
  //       id: "cliente producto",
  //       title: "cliente producto",
  //       type: "item",
  //       icon: <FaCheck size={12} />,
  //       permissions: ["admin", "editor"],
  //       navLink: "/cliente-producto",
  //     },
  //   ]
  // },
  {
    id: "Opciones Producto",
    title: "Opciones Producto",
    type: "collapse",
    icon: <FaProductHunt size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Productos",
        title: "Productos",
        type: "item",
        icon: <FaShopify size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/products"
      },
      {
        id: "ProductsRequest",
        title: "Solicitud por producto",
        type: "item",
        icon: <FaProductHunt size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/product-request"
      },
    ]
  },
  
];

const Comercial = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "Gestion de Bases",
    title: "Gestion de Bases",
    type: "collapse",
    icon: <FaDatabase size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Bases",
        title: "Bases",
        type: "item",
        icon: <BsDatabaseFillAdd size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/bases"
      },
      {
        id: "Gestion de numeros",
        title: "Gestion de numeros",
        type: "item",
        icon: <BiSolidContact size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-numeros"
      },
    ]
  },
  {
    id: "Gestion comercial",
    title: "Gestion comercial",
    type: "item",
    icon: <FaBusinessTime size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/gestion-comercial"
  },
  {
    id: "Contratos",
    title: "Contratos",
    type: "item",
    icon: <FaFileContract size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/contratos"
  },
  {
    id: "Agenda",
    title: "Agenda",
    type: "item",
    icon: <FaCalendar size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/agenda"
  },
  {
    id: "ClientesModulo",
    title: "Clientes",
    type: "collapse",
    icon: <FaUserTie size={16} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "crear-cliente",
        title: "Crear cliente",
        type: "item",
        icon: <FaUserTie size={16} />,
        permissions: ["admin", "editor"],
        navLink: "/cliente",
      },
      {
        id: "Productos",
        title: "Productos",
        type: "item",
        icon: <FaShopify size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/products"
      }
    ]
  },
  // {
  //   id: "Opciones cliente",
  //   title: "Opciones cliente",
  //   type: "collapse",
  //   icon: <FaUserTie size={20} />,
  //   permissions: ["admin", "editor"],
  //   children: [
  //     {
  //       id: "crear-cliente",
  //       title: "Gestión cliente",
  //       type: "item",
  //       icon: <FaCheck size={12} />,
  //       permissions: ["admin", "editor"],
  //       navLink: "/cliente",
  //     },
  //     {
  //       id: "cliente-producto",
  //       title: "Cliente producto",
  //       type: "item",
  //       icon: <FaCheck size={12} />,
  //       permissions: ["admin", "editor"],
  //       navLink: "/cliente-producto",
  //     },
  //   ]
  // },
  {
    id: "Opciones Producto",
    title: "Opciones Producto",
    type: "collapse",
    icon: <FaProductHunt size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Productos",
        title: "Productos",
        type: "item",
        icon: <FaShopify size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/products"
      },
      {
        id: "ProductsRequest",
        title: "Solicitud por producto",
        type: "item",
        icon: <FaProductHunt size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/product-request"
      },
    ]
  },
  // {
  //   id: "MiHojaVida",
  //   title: "Mi Hoja Vida",
  //   type: "item",
  //   icon: <FaHome size={20} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/mi-hoja-vida"
  // },
  // {
  //   id: "misPrestamos",
  //   title: "Mis Prestamos",
  //   type: "item",
  //   icon: <FaHandHolding size={12} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/mis-prestamos",
  // }, 
  // {
  //   id: "Inasistencias",
  //   title: "Inasistencias",
  //   type: "item",
  //   icon: <FaUserTimes size={20} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/inasistencias"
  // }
];

const Recepcion = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "Gestion de Bases",
    title: "Gestion de Bases",
    type: "collapse",
    icon: <FaDatabase size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Bases",
        title: "Bases",
        type: "item",
        icon: <BsDatabaseFillAdd size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/bases"
      },
      {
        id: "Gestion de numeros",
        title: "Gestion de numeros",
        type: "item",
        icon: <BiSolidContact size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-numeros"
      },
    ]
  },
  // {
  //   id: "MiHojaVida",
  //   title: "Mi Hoja Vida",
  //   type: "item",
  //   icon: <FaHome size={20} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/mi-hoja-vida"
  // },
  // {
  //   id: "misPrestamos",
  //   title: "Mis Prestamos",
  //   type: "item",
  //   icon: <FaHandHolding size={12} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/mis-prestamos",
  // },
  {
    id: "Agenda",
    title: "Agenda",
    type: "item",
    icon: <FaCalendar size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/agenda"
  },
  // {
  //   id: "Inasistencias",
  //   title: "Inasistencias",
  //   type: "item",
  //   icon: <FaUserTimes size={20} />,
  //   permissions: ["admin", "editor"],
  //   navLink: "/inasistencias"
  // }
];

const Administrativo = [
  {
    id: "home",
    title: "Inicio",
    type: "item",
    icon: <FaHome size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/home"
  },
  {
    id: "indicadores",
    title: "Indicadores",
    type: "item",
    icon: <FaChartLine size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/indicadores"
  },
  {
    id: "Gestion de Bases",
    title: "Gestion de Bases",
    type: "collapse",
    icon: <FaDatabase size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Bases",
        title: "Bases",
        type: "item",
        icon: <BsDatabaseFillAdd size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/bases"
      },
      {
        id: "Gestion de numeros",
        title: "Gestion de numeros",
        type: "item",
        icon: <BiSolidContact size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-numeros"
      },
      // {
      //   id: "GestionNumerosHistorial",
      //   title: "Historial Gestion de numeros",
      //   type: "item",
      //   icon: <FaList size={20} />,
      //   permissions: ["admin", "editor"],
      //   navLink: "/gestion-numeros-historial"
      // },
    ]
  },
  {
    id: "GestionComercialModule",
    title: "Gestión Comercial",
    type: "collapse",
    icon: <FaBusinessTime size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "GestionComercial",
        title: "Gestión comercial",
        type: "item",
        icon: <FaBusinessTime size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-comercial"
      },
      {
        id: "GestionComercialHistorial",
        title: "Historial Gestión comercial",
        type: "item",
        icon: <FaHistory size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/gestion-comercial-historial"
      },
      {
        id: "Contratos",
        title: "Contratos",
        type: "item",
        icon: <FaFileContract size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/contratos"
      },
      {
        id: "ContratosHistorial",
        title: "Historial Contratos",
        type: "item",
        icon: <FaHistory size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/contratos-historial"
      },
      {
        id: "PlantillasContratosAdmin",
        title: "Plantillas Contratos",
        type: "item",
        icon: <FaFileContract size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/contratos-plantillas"
      }
    ]
  },
  {
    id: "producto-inhouse",
    title: "Productos Inhouse",
    type: "item",
    icon: <FaBoxOpen size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/producto-inhouse"
  },
  {
    id: "Facturacion",
    title: "Facturación",
    type: "collapse",
    icon: <FaRegMoneyBillAlt size={20} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Facturas",
        title: "Facturas",
        type: "item",
        icon: <FaRegMoneyBillAlt size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/facturacion"
      },
      // {
      //   id: "FacturasHistorial",
      //   title: "Historial Facturas",
      //   type: "item",
      //   icon: <FaList size={20} />,
      //   permissions: ["admin", "editor"],
      //   navLink: "/facturacion-historial"
      // },
      {
        id: "CobrosAdmin",
        title: "Cobros",
        type: "item",
        icon: <FaHandHoldingUsd size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/facturacion-cobros"
      },
    ]
  },
  {
    id: "ClientesModulo",
    title: "Clientes",
    type: "collapse",
    icon: <FaUserTie size={16} />,
    permissions: ["admin", "editor"],
    children: [
      {
        id: "Clientes",
        title: "Clientes",
        type: "item",
        icon: <FaUserTie size={16} />,
        permissions: ["admin", "editor"],
        navLink: "/cliente",
      },
      {
        id: "Productos",
        title: "Productos",
        type: "item",
        icon: <FaShopify size={20} />,
        permissions: ["admin", "editor"],
        navLink: "/products"
      },
    ]
  },
  {
    id: "Agenda",
    title: "Agenda",
    type: "item",
    icon: <FaCalendar size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/agenda"
  },

];

const roleMenus = {
  [ROLES.ADMIN]: Admin,
  [ROLES.LIDER_ADMINISTRATIVO]: Administrativo,
  [ROLES.COMERCIAL]: Comercial,
  [ROLES.RECURSOS_HUMANOS]: RecursosHumanos,
  [ROLES.SOPORTE]: Soporte,
  [ROLES.NOMINA]: Nomina,
  [ROLES.AGENTE]: Agente,
  [ROLES.RECEPCION]: Recepcion
};

const navigationConfig = roleMenus[user?.profile] || [];


export default navigationConfig
